import 'element-closest';
import arrayFrom from 'array-from';
import SmoothScroll from 'smooth-scroll';

class AnchorScroll {
  constructor() {
    const headerEl = document.querySelector('.c-header');
    const heroEl =  document.querySelector('.c-hero');
    const triggerEls = document.querySelectorAll('[data-scroll]');

    arrayFrom(triggerEls).forEach( triggerEl => {
      triggerEl.addEventListener('click', event => {
        event.preventDefault();
        this.startScrolling(triggerEl, headerEl, heroEl);
      });
    });
  }

  startScrolling (triggerEl, headerEl, heroEl) {
    const targetSelector = triggerEl.getAttribute('href');
    const targetEl = document.querySelector(targetSelector);
    const offset = this.getOffset(targetEl, headerEl, heroEl);

    SmoothScroll.animateScroll(targetEl, null, { offset });
  }

  getOffset(targetEl, headerEl, heroEl) {
    const headerHeight = this.getHeaderHeight(headerEl);

    if ( targetEl.closest('.o-sticky-top') ) {
      const { top, height } = heroEl.getBoundingClientRect();
      const heroOffset = height + top - headerHeight;

      if (heroOffset > 0) {
        return -heroOffset + headerHeight;
      }

      return headerHeight;
    }

    return headerHeight;
  }

  getHeaderHeight (headerEl) {
    const MINIMISED_HEADER_HEIGHT = 100;
    const isLargeWindow = matchMedia('(min-width: 1024px)').matches;

    if (isLargeWindow) {
      return MINIMISED_HEADER_HEIGHT;
    }

    return headerEl.offsetHeight;
  }
}

export default AnchorScroll;
